import { OrganizationJson } from '@/types';
import { createRandomCompany } from './organizations.mock';

const companyMock: OrganizationJson.Organization = createRandomCompany();

export default companyMock;
